import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./video_box_thumb.module.scss";

const VideoBoxThumb = () => {
  return (
    <div className={styles.box_thum}>
      <div className={styles.video_thumbnail}>
        <Link legacyBehavior href="#">
          <a>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/blog/blog1.png")}
                alt="video thumbnail"
              />
            </div>
          </a>
        </Link>
      </div>
      <div className={styles.video_desc}>
        <Link legacyBehavior href="#">
          <a>
            <div className={styles.title}>Top University</div>
          </a>
        </Link>
        <div className={styles.number}>10 video</div>
      </div>
    </div>
  );
};

export default VideoBoxThumb;
